import { Menu } from "@mui/material";
import { useState } from "react";

type ContextMenuProps<TItem> = {
    children: (bind: {
        onContextMenu: (e: React.MouseEvent, position: TItem) => void;
    }) => React.ReactElement;
    renderItems: (position: TItem, close: () => void) => React.ReactNode;
};

type ContextMenuState<TItem> = {
    mouseX: number;
    mouseY: number;
    item: TItem;
};

export function ContextMenu<TItem>({
    children,
    renderItems
}: ContextMenuProps<TItem>){
    const [contextMenu, setContextMenu] = useState<ContextMenuState<TItem> | null>(null);
    
    const handleClose = (event: any) => {
        setContextMenu(null);
        event.stopPropagation();
    };

    const handleContextMenu = (event: React.MouseEvent, item: TItem) => {
        event.preventDefault();
        setContextMenu(
            contextMenu === null
                ? {
                    mouseX: event.clientX + 6,
                    mouseY: event.clientY + 2,
                    item: item,
                }
                : null,
        );
    };
    
    return(
        <>
            {children({ onContextMenu: handleContextMenu })}
            
            <Menu
                transitionDuration={0}
                open={contextMenu !== null}
                onClose={handleClose}
                onContextMenu={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    handleClose(e);
                    setTimeout(() => {
                        const { clientX, clientY } = e;
                        const elementAtPoint = document.elementFromPoint(e.clientX, e.clientY);
                        if (elementAtPoint instanceof HTMLElement) {
                            const simulatedEvent = new MouseEvent('contextmenu', {
                                bubbles: true,
                                cancelable: true,
                                clientX,
                                clientY,
                            });
                            elementAtPoint.dispatchEvent(simulatedEvent);
                        }
                    }, 1);
                }}
                anchorReference="anchorPosition"
                anchorPosition={
                    contextMenu !== null
                        ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
                        : undefined
                }
                sx={
                    {
                        mt: "1px",
                        "& .MuiMenu-paper": {
                            backgroundColor: 'rgba(240,240,240)'
                        },
                    }
                }
            >
                {
                    contextMenu?.item
                        ? renderItems(contextMenu.item, () => setContextMenu(null))
                        : null
                }
            </Menu>
        </>
    )
}